import Fuse from 'fuse.js';

export interface Proverb {
  marathi: string;
  literal: string;
  idiomatic: string;
}

// Fuse.js configuration for fuzzy searching
export const createSearchEngine = (proverbs: Proverb[]) => {
  const options = {
    // Search in all three fields
    keys: [
      {
        name: 'marathi',
        weight: 0.4
      },
      {
        name: 'literal',
        weight: 0.3
      },
      {
        name: 'idiomatic',
        weight: 0.3
      }
    ],
    // Fuzzy matching threshold (0.0 = exact match, 1.0 = match anything)
    threshold: 0.3,
    // Distance between characters that still counts as a match
    distance: 100,
    // Minimum characters before search starts
    minMatchCharLength: 2,
    // Include match information for highlighting (future feature)
    includeMatches: true,
    includeScore: true,
    // Support for Unicode (important for Marathi text)
    ignoreLocation: true,
    useExtendedSearch: false
  };

  return new Fuse(proverbs, options);
};

export const searchProverbs = (
  fuse: Fuse<Proverb>,
  query: string
): Proverb[] => {
  if (!query || query.trim().length < 2) {
    return [];
  }

  const results = fuse.search(query);
  return results.map(result => result.item);
};
